import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import dashboardStore from "./modules/dashboardStore";
import notificationStore from "./modules/notificationStore";
import navigationStore from "./modules/navigationStore.js";
import sessionStore from "./modules/sessionStore.js";
import profileStore from "./modules/profileStore.js";
import addressbookStore from "./modules/addressbookStore.js";
import contactStore from "./modules/contactStore.js";
import folderStore from "./modules/folderStore.js";
import documentStore from "./modules/documentStore.js";
import documentTemplateStore from "./modules/documentTemplateStore";
import templateLibraryStore from "./modules/templateLibraryStore";
import documentImageStore from "./modules/documentImageStore";
import documentTypeStore from "./modules/documentTypeStore";
import projectStore from "./modules/projectStore";
import mediumStore from "./modules/mediumStore";
import historyStore from "./modules/historyStore";
import titleStore from "./modules/titleStore";
import organizationStore from "./modules/organizationStore";
import presetStore from "./modules/presetStore";
import meterUnitTariffStore from "./modules/project/metering/meterUnitTariffStore";

import localizationStore from "./modules/localization/index";
import projectMeteringStore from "./modules/project/metering/index";
import projectAccountingStore from "./modules/project/accounting/index";
import pricingOtherStore from "./modules/project/other/index";
import pricingStore from "./modules/pricingStore";
import tariffPlanComponentStore from "./modules/project/accounting/tariffPlanComponentStore.js";
import tariffPlanModifiersStore from "./modules/project/accounting/tariffPlanModifiersStore.js";
import tariffPlanOperandsStore from "./modules/project/accounting/tariffPlanOperandsStore.js";
import tariffPlanTimeframesStore from "./modules/project/accounting/tariffPlanTimeframesStore.js";
import userGroupStore from "./modules/userGroupStore";
import userStore from "./modules/userStore";

export default new Vuex.Store({
  modules: {
    dashboardStore,
    notificationStore,
    navigationStore,
    sessionStore,
    profileStore,
    addressbookStore,
    contactStore,
    localizationStore,
    folderStore,
    documentStore,
    documentTemplateStore,
    templateLibraryStore,
    documentImageStore,
    documentTypeStore,
    projectStore,
    projectMeteringStore,
    mediumStore,
    historyStore,
    titleStore,
    projectAccountingStore,
    organizationStore,
    presetStore,
    pricingStore,
    pricingOtherStore,
    meterUnitTariffStore,
    tariffPlanComponentStore,
    tariffPlanModifiersStore,
    tariffPlanOperandsStore,
    tariffPlanTimeframesStore,
    userGroupStore,
    userStore
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {}
});
